/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import {
  Modal,
  Typography,
  Button,
  Box,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton
} from '@mui/material';
import PropTypes from 'prop-types';
import { Close } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import RolePermAction from '../../store/actions/RolePermAction';

function RoleDelete({ itemId, openmodal, onCloseModal }) {
  const dispatch = useDispatch();

  const handleClickDelete = () => {
    dispatch(RolePermAction.deleteItem(itemId, onCloseModal));
  };

  return (
    <Modal
      className="cmn__delete__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Card>
          <CardHeader
            title="Delete"
            action={
              <IconButton
                aria-label="settings"
                onClick={() => {
                  onCloseModal();
                }}
              >
                <Close />
              </IconButton>
            }
          />
          <CardContent>
            <Typography variant="h3" component="h3">
              Are you sure <br /> you want to delete this role?
            </Typography>
          </CardContent>
          <CardActions sx={{ justifyContent: 'center' }}>
            <Button
              type="button"
              className="save__btn"
              variant="contained"
              color="secondary"
              size="medium"
              onClick={() => {
                handleClickDelete();
              }}
            >
              Yes
            </Button>
            <Button
              type="button"
              className="cancel__btn"
              variant="contained"
              color="info"
              // fullWidth
              size="medium"
              onClick={() => {
                onCloseModal();
              }}
            >
              No
            </Button>
          </CardActions>
        </Card>
      </Box>
    </Modal>
  );
}

RoleDelete.propTypes = {
  itemId: PropTypes.string.isRequired,
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default RoleDelete;
